import { clampPaneWidth, type PaneWidthConfig } from '@/lib/resizable-panes'
import { useCallback, useState, type PointerEvent as ReactPointerEvent } from 'react'

export function useResizablePane({
  initialWidth,
  config,
  resizeMultiplier = 1,
}: {
  initialWidth: number
  config: PaneWidthConfig
  resizeMultiplier?: 1 | -1
}) {
  const [width, setWidth] = useState(initialWidth)
  const [collapsed, setCollapsed] = useState(false)

  const startResize = useCallback(
    (event: ReactPointerEvent<HTMLButtonElement>) => {
      event.preventDefault()
      const startX = event.clientX
      const startWidth = width

      function onPointerMove(moveEvent: globalThis.PointerEvent) {
        const nextWidth = startWidth + (moveEvent.clientX - startX) * resizeMultiplier
        setCollapsed(false)
        setWidth(clampPaneWidth(nextWidth, config))
      }

      function onPointerUp() {
        window.removeEventListener('pointermove', onPointerMove)
      }

      window.addEventListener('pointermove', onPointerMove)
      window.addEventListener('pointerup', onPointerUp, { once: true })
    },
    [config, resizeMultiplier, width],
  )

  return {
    width,
    collapsed,
    setCollapsed,
    startResize,
    toggleCollapsed: () => setCollapsed((current) => !current),
  }
}
